export class AlertMessage {
	errorCode: string;
	errorMsg: string;
	successMsg: string;
	date: Date;

	constructor(
		errorCode?: string,
		errorMsg?: string,
		successMsg?: string
	) {
		this.errorCode = errorCode;
		this.errorMsg = errorMsg;
		this.successMsg = successMsg;
		this.date = null;
	}
}

export class AuctionMessage {
	errorCode: string;
	errorMsg: string;
	successMsg: string;
	startDate: Date;
	endDate: Date;

	constructor(
		errorCode?: string,
		errorMsg?: string, successMsg?: string
	) {
		this.errorCode = errorCode;
		this.errorMsg = errorMsg;
		this.successMsg = successMsg;
		this.startDate = null;
		this.endDate = null;
	}
}

export class EmailData {
	email: string;
	recipients: string;
	ccRecipients: string;
	subject: string;
}

export class RatingData {
	idAuctioneer: number;
	rating: number;
	idAuction: number;
	idLot: number;
	idFeedback: number;
}